<template>
  <!--==================
    component shows all operators in operator management page (admin)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <div class="card">
      <div class="table-responsive">
        <table id="table-operator" class="table table-sm table-nowrap card-table">
          <thead class="text-primary">
            <tr>
              <th>#</th>
              <th>COMPANY NAME</th>
              <th>STATUS</th>
              <th>TAG</th>
              <th>PACKAGE</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(operator, index) in operators"
              :key="operator.id"
              :data-position="operator.position"
              :data-id="operator.id"
            >
              <td :id="'row-' + operator.id">{{ index + 1 }}</td>
              <td class="font-weight-bold">
                <a class="d-block p-3" :href="operatorUrl + operator.id" target="_blank">{{ operator.companyName }}</a>
              </td>
              <td>
                <select
                  @change="status($event)"
                  class="form-control form-control-sm"
                  :value="operator.status"
                  :data-id="operator.id"
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </td>
              <td>
                <select
                  @change="tag($event)"
                  class="form-control form-control-sm"
                  :value="operator.tag"
                  :data-id="operator.id"
                >
                  <option value="">---none---</option>
                  <option value="seller">Best Seller</option>
                  <option value="offer">Best Offer</option>
                  <option value="review">Best Review</option>
                  <option value="rated">Top Rated</option>
                </select>
              </td>
              <td>
                <a
                  class="btn btn-sm btn-success mr-2"
                  :href="'/dashboard/package/operator/' + operator.id + '?act=management'"
                  target="_blank"
                  >Management</a
                >
                <!-- <a
                  class="btn btn-sm btn-success ml-2"
                  :href="'/dashboard/package/operator/' + operator.id + '?act=rearrangement'"
                  target="_blank"
                  >Rearrangement</a
                > -->
              </td>
              <td class="text-right">
                <button @click="edit($event)" class="btn btn-sm btn-primary mr-2" :data-id="operator.id">Edit</button>
                <button
                  @click="remove($event)"
                  class="btn btn-sm btn-danger ml-2"
                  :data-id="operator.id"
                  :data-index="index"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Operator",

  computed: {
    ...mapGetters(["operators"]),

    operatorUrl() {
      return process.env.VUE_APP_OPERATOR_URL;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchOperators();
      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions(["fetchOperators", "updateOperatorStatus", "updateOperatorTag", "deleteOperator", "hideBarLoading"]),

    status(e) {
      let id = e.target.getAttribute("data-id");
      let status = e.target.value;

      this.updateOperatorStatus({ id, status });
    },

    tag(e) {
      let id = e.target.getAttribute("data-id");
      let tag = e.target.value;

      this.updateOperatorTag({ id, tag });
    },

    edit(e) {
      let id = e.target.getAttribute("data-id");

      window.open("/dashboard/user/setting/" + id, "_blank");
    },

    remove(e) {
      let id = e.target.getAttribute("data-id");
      let index = e.target.getAttribute("data-index");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this operator?",
        buttons: {
          confirm: () => {
            dP.deleteOperator({ id, flag: "operator" });
          },
          cancel: () => {},
        },
      });
    },
  },
};
</script>
